import { render, staticRenderFns } from "./innerOriginalManuscript.vue?vue&type=template&id=5001981e&scoped=true&"
import script from "./innerOriginalManuscript.vue?vue&type=script&lang=js&"
export * from "./innerOriginalManuscript.vue?vue&type=script&lang=js&"
import style0 from "./innerOriginalManuscript.vue?vue&type=style&index=0&id=5001981e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5001981e",
  null
  
)

export default component.exports